<template>
  <div class="vx-row w-full m-0 flex flex-col">
    <div class="vx-row w-full m-0 flex flex-row">
      <div class="vx-col flex">
        <div class="keys">
          <div class="up left arr" @click="setPtzWay('up-left')"><i class="fa fa-arrow-up rotate--45"></i></div>
          <div class="up arr" @click="setPtzWay('up')"><i class="fa fa-arrow-up"></i></div>
          <div class="up right arr" @click="setPtzWay('up-right')"><i class="fa fa-arrow-up rotate-45"></i></div>
          <br />
          <div class="left arr" @click="setPtzWay('left')"><i class="fa fa-arrow-left"></i></div>
          <div class="arr"><i class="fa fa-circle"></i></div>
          <div class="right arr" @click="setPtzWay('right')"><i class="fa fa-arrow-right"></i></div>

          <br />
          <div class="down left arr" @click="setPtzWay('down-left')"><i class="fa fa-arrow-down rotate-45"></i></div>
          <div class="down arr" @click="setPtzWay('down')"><i class="fa fa-arrow-down"></i></div>
          <div class="down right arr" @click="setPtzWay('down-right')"><i class="fa fa-arrow-down rotate--45"></i></div>
        </div>
        <div class="part-bg pl-4 flex-col justify-start">
          <vue-slider class="vertical-slide-input" v-model="zoom_value" v-bind="options"></vue-slider>

          <div class="mt-2 py-2 field-desc">Zoom</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import $ from 'jquery'

export default {
  name: 'PTZController',
  props: {
    event: {
      type: Object
    }
  },
  data () {
    return {
      pan_value: 0,
      tilt_value: 0,
      zoom_value: 100,
      rotation_value: 0,
      maxPan: 0,
      maxTilt: 0,
      errorPtz: false,
      options: {
        dotSize: 14,
        width: '4px',
        height: '110px',
        contained: false,
        direction: 'btt',
        min: 100,
        max: 200,
        interval: 1,
        disabled: false,
        clickable: true,
        duration: 0.5,
        adsorb: false,
        lazy: false,
        tooltip: 'active',
        tooltipPlacement: 'top',
        tooltipFormatter: void 0,
        useKeyboard: false,
        keydownHook: null,
        dragOnClick: false,
        enableCross: true
      }
    }
  },
  watch: {
    camera (val) {
      console.log('camera here', val)
      if (val !== null) {
        this.maxPan = parseInt(val.max_pan)
        this.maxTilt = parseInt(val.max_tilt)
        this.northPan = parseInt(val.kuzey_sabiti)
      }
    },
    zoom_value () {
      this.setPtzWay('none')
    }
  },
  computed: {
    ptz_data () {
      return this.$store.state.ptz[1]
    },
    camera () {
      return this.$store.state.camera
    }
  },
  beforeDestroy () {
    this.$store.commit('SET_PTZ', null)
    this.$store.commit('SET_CAMERA', null)
  },
  mounted () {
    //this.handleRotationKnob(0)
    this.getPTZdata()
  },
  methods: {
    setPtzWay (way) {
      const payload = {
        id: this.event.id,
        rotation: way,
        zoom: this.zoom_value
      }
      console.log('event ptz payload', payload)
      this.$store.dispatch('setCameraRotation', payload)
        .then((response) => {
          this.errorPtz = false
          console.log('set ptz result', response)
          this.zoom_value = this.ptz_data[2]
        })
        .catch(error => {
          console.log('error', error)
          this.$vs.notify({
            title: 'Sorun',
            text: error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
          this.errorPtz = true
        })
    },
    getPanAngle360Frontend (angle) {
      let panAngle = 0

      if (angle > this.northPan) {
        panAngle = angle - this.northPan
      } else if (angle < this.northPan) {
        panAngle = this.maxPan - (this.northPan - angle)
      } else if (angle === this.northPan) {
        panAngle = 0
      }
      const panAngleNormalisation = (panAngle / this.maxPan) * 360

      return panAngleNormalisation
    },
    getTiltAngle360Frontend (tilt) {
      let angle = 0
      angle = ((tilt / this.maxTilt) * 90)
      return angle
    },
    getTiltAngleBackend (angle) {
      console.log(angle)
      const tilt = Math.round((angle * this.maxTilt) / 90)
      console.log('converted angle', tilt)
      return tilt
    },
    getPanAngleBackend (angle) {
      console.log(angle)
      const ratio = this.maxPan / 360
      const result = Math.round(angle * ratio)
      console.log('converted angle', result)
      return result
    },
    handlePanKnob (angle_) {
      const self = this
      const knob = $('.knob.pan')
      const tick = $('.pan .tick')
      let angle = angle_
      const minangle = 0
      const maxangle = 360

      function setAngle () {
        // rotate knob
        knob.css({
          '-moz-transform': `rotate(${angle}deg)`,
          '-webkit-transform': `rotate(${angle}deg)`,
          '-o-transform': `rotate(${angle}deg)`,
          '-ms-transform':`rotate(${angle}deg)`,
          'transform': `rotate(${angle}deg)`
        })

        // highlight ticks
        const activeTicks = (Math.round(angle / 10) + 1)
        tick.removeClass('activetick')
        tick.slice(0, activeTicks).addClass('activetick')

        // update % value in text
        const pc = Math.round(angle)
        self.pan_value = pc
        console.log('pan', self.pan_value)

      }
      function moveKnob (direction) {

        if (direction === 'up') {
          if ((angle + 5) <= maxangle) {
            angle = angle + 5
            setAngle()
          } else {
            angle = 0
            setAngle()
          }
        } else if (direction === 'down') {
          if ((angle - 5) >= minangle) {
            angle = angle - 5
            setAngle()
          } else {
            angle = 360
            setAngle()
          }
        }

      }
      // mousewheel event - firefox
      knob.bind('DOMMouseScroll', function (e) {
        if (e.originalEvent.detail > 0) {
          moveKnob('down')
        } else {
          moveKnob('up')
        }
        return false
      })

      // mousewheel event - ie, safari, opera
      knob.bind('mousewheel', function (e) {
        if (e.originalEvent.wheelDelta < 0) {
          moveKnob('down')
        } else {
          moveKnob('up')
        }
        return false
      })

      setAngle()
    },
    handleTiltKnob (angle_) {
      const self = this
      const knob = $('.knob.tilt')
      const tick = $('.tilt .tick')
      let angle = angle_
      const minangle = 0
      const maxangle = 360

      function setAngle () {
        // rotate knob
        knob.css({
          '-moz-transform': `rotate(${angle}deg)`,
          '-webkit-transform': `rotate(${angle}deg)`,
          '-o-transform': `rotate(${angle}deg)`,
          '-ms-transform':`rotate(${angle}deg)`,
          'transform': `rotate(${angle}deg)`
        })

        // highlight ticks
        const activeTicks = (Math.round(angle / 10) + 1)
        tick.removeClass('activetick')
        tick.slice(0, activeTicks).addClass('activetick')

        // update % value in text
        const pc = Math.round(angle)
        self.tilt_value = pc
        console.log('tilt', self.tilt_value)

      }

      function moveKnob (direction) {

        if (direction === 'up') {
          if ((angle + 5) <= maxangle) {
            angle = angle + 5
            setAngle()
          } else {
            angle = 0
            setAngle()
          }
        } else if (direction === 'down') {
          if ((angle - 5) >= minangle) {
            angle = angle - 5
            setAngle()
          } else {
            angle = 360
            setAngle()
          }
        }

      }
      // mousewheel event - firefox
      knob.bind('DOMMouseScroll', function (e) {
        if (e.originalEvent.detail > 0) {
          moveKnob('down')
        } else {
          moveKnob('up')
        }
        return false
      })

      // mousewheel event - ie, safari, opera
      knob.bind('mousewheel', function (e) {
        if (e.originalEvent.wheelDelta < 0) {
          moveKnob('down')
        } else {
          moveKnob('up')
        }
        return false
      })
      setAngle()
    },
    handleRotationKnob (angle) {
      const self = this
      const knob = $('.knob.rotation')
      const tick = $('.rotation .tick')
      const minangle = 0
      const maxangle = 360

      function setAngle () {

        // rotate knob
        knob.css({
          '-moz-transform': `rotate(${angle}deg)`,
          '-webkit-transform': `rotate(${angle}deg)`,
          '-o-transform': `rotate(${angle}deg)`,
          '-ms-transform':`rotate(${angle}deg)`,
          'transform': `rotate(${angle}deg)`
        })

        // highlight ticks
        const activeTicks = (Math.round(angle / 10) + 1)
        tick.removeClass('activetick')
        tick.slice(0, activeTicks).addClass('activetick')

        // update % value in text
        const pc = Math.round((angle / 270) * 100)
        self.rotation_value = pc
        console.log('tilt', self.rotation_value)

      }

      function moveKnob (direction) {

        if (direction === 'up') {
          if ((angle + 5) <= maxangle) {
            angle = angle + 5
            setAngle()
          } else {
            angle = 0
            setAngle()
          }
        } else if (direction === 'down') {
          if ((angle - 5) >= minangle) {
            angle = angle - 5
            setAngle()
          } else {
            angle = 360
            setAngle()
          }
        }

      }
      // mousewheel event - firefox
      knob.bind('DOMMouseScroll', function (e) {
        if (e.originalEvent.detail > 0) {
          moveKnob('down')
        } else {
          moveKnob('up')
        }
        return false
      })

      // mousewheel event - ie, safari, opera
      knob.bind('mousewheel', function (e) {
        if (e.originalEvent.wheelDelta < 0) {
          moveKnob('down')
        } else {
          moveKnob('up')
        }
        return false
      })
    },
    getPTZdata () {
      const payload = {
        id: this.event.id
      }
      console.log('event cam payload', payload)
      this.$store.dispatch('getEventCamera', payload)
        .then((response) => {
          this.errorPtz = false
          console.log('ptz event cam', response)
          console.log('ptz', this.ptz_data)
          this.zoom_value = this.ptz_data[2]
          this.handlePanKnob(this.getPanAngle360Frontend(this.ptz_data[0]))
          this.handleTiltKnob(this.getTiltAngle360Frontend(this.ptz_data[1]))
        })
        .catch(error => {
          console.log('error', error)
          this.$vs.notify({
            title: 'Sorun',
            text: error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
          this.errorPtz = true
        })
    },
    setPTZdata () {
      const ptz_array = []
      ptz_array.push(this.getPanAngleBackend(this.pan_value), this.getTiltAngleBackend(this.tilt_value), this.zoom_value)
      const payload = {
        id: this.event.id,
        ptz: ptz_array
      }
      console.log('event ptz payload', payload)
      this.$store.dispatch('setCameraPtz', payload)
        .then((response) => {
          this.errorPtz = false
          console.log('set ptz result', response)
          console.log('ptz', this.ptz_data)
          this.zoom_value = this.ptz_data[2]
          this.handlePanKnob(this.getPanAngle360Frontend(this.ptz_data[0]))
          this.handleTiltKnob(this.getTiltAngle360Frontend(this.ptz_data[1]))
        })
        .catch(error => {
          console.log('error', error)
          this.$vs.notify({
            title: 'Sorun',
            text: error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
          this.errorPtz = true
        })
    }
  }
}
</script>

<style lang="scss">

.rotate--45 {
  transform: rotate(-45deg);
}
.rotate-45 {
  transform: rotate(45deg);
}
.keys {
  font-family: 'Lato', sans-serif;
  text-align: center;
}

.arr {
  cursor: pointer;
  width: 50px;
  height: auto;
  text-align: center;
  line-height: 25px;
  background: grey;
  color: white;
  font-size: 15px;
  border-right: 5px solid darken(grey, 20);
  border-bottom: 5px solid darken(grey, 20);
  border-left: 5px solid darken(grey, 15);
  border-top: 5px solid darken(grey, 10);
  display: inline-block;
  margin: 2.5px;
  transition: all .05s linear;

  &:active {
    border-bottom: 2.5px solid darken(grey, 20);
    text-shadow: 0 0 10px white, 0 0 5px white, 0 0 10px white;
    transform: translate(0, 2px);
  }
  user-select: none;
}

.up {
  position: relative;
  top: -1px;
}

.pressed {
  border-bottom: 5px solid darken(grey, 20);
  text-shadow: 0 0 5px white;
  transform: translate(0, 2px);
}

</style>
